module.exports = __webpack_public_path__ + "static/media/21.08198a32.png";